module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/berries_aa368f.jpg";